import angular from 'angular';
import { v4 as uuidv4 } from 'uuid';

import calendarSdkFacadeImport from '../../calendarSdkFacade';

import SlingApiImport from './SlingApi';
import SlingAnalyticsImport from './SlingAnalytics';
import GoogleAnalyticsImport from './GoogleAnalytics';
import IntercomServiceImport from './IntercomService';
import AlertServiceImport from './AlertService';
import AttachmentUtilsImport from './AttachmentUtils';
import ChooseServiceImport from './ChooseService';
import ConfirmServiceImport from './ConfirmService';
import MentionsImport from './Mentions';
import StatusServiceImport from './StatusService';
import TitleImport from './Title';
import UploadImport from './Upload';
import UtilsServiceImport from './UtilsService';
import AvailabilityUtilsImport from './AvailabilityUtils';
import RenderContentImport from './RenderContent';
import RestUtilsImport from './RestUtils';
import GoogleMapsServiceImport from './GoogleMapsService';
import GoogleCalendarUtilsImport from './GoogleCalendarUtils';
import PrintServiceImport from './PrintService';
import CurrencyServiceImport from './CurrencyService';
import SalesServiceImport from './SalesService';
import RefreshDataImport from './RefreshData';
import AvatarErrorsServiceImport from './AvatarErrorsService';
import ModalStackImport from './ModalStack';
import KeyboardServiceImport from './KeyboardService';
import AppBootstrapImport from './AppBootstrap';
import NoCacheInterceptorImport from './NoCacheInterceptor';
import AlertHttpResponseInterceptorImport from './AlertHttpResponseInterceptor';
import PremiumRequiredHttpInterceptorImport from './PremiumRequiredHttpInterceptor';
import ReadonlyModeHttpRequestInterceptorImport from './ReadonlyModeHttpRequestInterceptor';
import MarshalInterceptorImport from './MarshalInterceptor';
import SocketImport from './Socket';
import FormatDateImport from './FormatDate';
import TabsControlImport from './TabsControl';
import IgnoreServerErrorsImport from './IgnoreServerErrors';
import AnnouncementServiceImport from './AnnouncementService';
import KioskService from './KioskService';
import WhatsNewService from './WhatsNewService';
import HttpLayerFactory from './HttpLayerFactory';
import WindowScroll from './WindowScroll';
import LaborUISchema from './LaborUISchema';
import ConversationService from './ConversationService';
import PremiumDiscoveryService from './PremiumDiscoveryService';
import DayPartsService from './DayPartsService';
import ConfirmationModal from './ConfirmationModalService';
import TopSectionDisplay from './TopSectionDisplay';
import NoScrollServiceImport from './NoScrollService';
import WindowLocation from './WindowLocation';
import ReactNotificationService from './ReactNotificationService';

const servicesModule = angular.module('components.services', []);

servicesModule.factory('uuid', () => ({
  new: () => uuidv4(),
}));
servicesModule.service('SlingApi', SlingApiImport);
servicesModule.service('SlingAnalytics', SlingAnalyticsImport);
servicesModule.service('GoogleAnalytics', GoogleAnalyticsImport);
servicesModule.service('IntercomService', IntercomServiceImport);
servicesModule.service('AlertService', AlertServiceImport);
servicesModule.service('AttachmentUtils', AttachmentUtilsImport);
servicesModule.service('ChooseService', ChooseServiceImport);
servicesModule.service('ConfirmService', ConfirmServiceImport);
servicesModule.service('Mentions', MentionsImport);
servicesModule.service('StatusService', StatusServiceImport);
servicesModule.service('Title', TitleImport);
servicesModule.service('Upload', UploadImport);
servicesModule.service('Utils', UtilsServiceImport);
servicesModule.service('AvailabilityUtils', AvailabilityUtilsImport);
servicesModule.service('RenderContent', RenderContentImport);
servicesModule.service('RestUtils', RestUtilsImport);
servicesModule.service('GoogleMapsService', GoogleMapsServiceImport);
servicesModule.service('PrintService', PrintServiceImport);
servicesModule.service('CurrencyService', CurrencyServiceImport);
servicesModule.service('SalesService', SalesServiceImport);
servicesModule.service('RefreshData', RefreshDataImport);
servicesModule.service('AvatarErrorsService', AvatarErrorsServiceImport);
servicesModule.service('ModalStack', ModalStackImport);
servicesModule.service('KeyboardService', KeyboardServiceImport);
servicesModule.service('AppBootstrap', AppBootstrapImport);
servicesModule.service('GoogleCalendarUtils', GoogleCalendarUtilsImport);
servicesModule.service('KioskService', KioskService);
servicesModule.service('WhatsNewService', WhatsNewService);
servicesModule.factory('NoCacheInterceptor', NoCacheInterceptorImport);
servicesModule.factory('AlertHttpResponseInterceptor', AlertHttpResponseInterceptorImport);
servicesModule.factory('PremiumRequiredHttpInterceptor', PremiumRequiredHttpInterceptorImport);
servicesModule.factory(
  'ReadonlyModeHttpRequestInterceptor',
  ReadonlyModeHttpRequestInterceptorImport
);
servicesModule.factory('MarshalInterceptor', MarshalInterceptorImport);
servicesModule.factory('Socket', SocketImport);
servicesModule.factory('formatDate', FormatDateImport);
servicesModule.factory('TabsControl', TabsControlImport);
servicesModule.provider('IgnoreServerErrors', IgnoreServerErrorsImport);
servicesModule.provider('AnnouncementService', AnnouncementServiceImport);
servicesModule.factory('sdk', () => calendarSdkFacadeImport);
servicesModule.factory('HttpLayer', HttpLayerFactory);
servicesModule.service('WindowScroll', WindowScroll);
servicesModule.service('LaborUISchema', LaborUISchema);
servicesModule.service('ConversationService', ConversationService);
servicesModule.service('PremiumDiscoveryService', PremiumDiscoveryService);
servicesModule.service('DayPartsService', DayPartsService);
servicesModule.service('ConfirmationModal', ConfirmationModal);
servicesModule.service('TopSectionDisplay', TopSectionDisplay);
servicesModule.service('NoScrollService', NoScrollServiceImport);
servicesModule.factory('WindowLocation', WindowLocation);
servicesModule.service('ReactNotificationService', ReactNotificationService);

servicesModule.config(($httpProvider) => {
  $httpProvider.interceptors.push('NoCacheInterceptor');
  $httpProvider.interceptors.push('AlertHttpResponseInterceptor');
  $httpProvider.interceptors.push('PremiumRequiredHttpInterceptor');
  $httpProvider.interceptors.push('ReadonlyModeHttpRequestInterceptor');
  $httpProvider.interceptors.push('MarshalInterceptor');
});

export default servicesModule.name;
